<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'sws_air_simulation' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <ng-container class="contentDiv">
      <div class="select-group">
        <label class="select-label">{{ 'INSTALLATION_PLACE' | translate }}</label>
        <div class="search-wrapper">
          <ion-icon src="assets/icons/search-icon.svg" class="search-icon"></ion-icon>
          <div class="divider"></div>
          <input #searchInput type="text" [(ngModel)]="locationQuery" (input)="onSearchChange()"
            class="location-input" />
          <ion-icon *ngIf="locationQuery" name="close-circle" class="clear-icon" (click)="clearSearch()"></ion-icon>
        </div>
      </div>

      <div class="coordinates-row">
        <div class="coordinate-group">
          <label class="coordinate-label">{{ 'LATITUDE' | translate }} °</label>
          <div class="coordinate-display">{{ displayLatitude }}</div>
        </div>
        <div class="coordinate-group">
          <label class="coordinate-label">{{ 'LONGITUDE' | translate }} °</label>
          <div class="coordinate-display">{{ displayLongitude }}</div>
        </div>
      </div>

      <ion-button expand="block" fill="outline" class="search-coordinates-btn"
        [disabled]="!locationQuery || isSearching" (click)="searchCoordinates()">
        <ion-spinner *ngIf="isSearching" name="crescent"></ion-spinner>
        <span *ngIf="!isSearching">{{ 'SEARCH_COORDINATES' | translate }}</span>
      </ion-button>

      <div class="google-attribution">
        <p class="powered-text">
          {{ 'SEARCH_POWERED_BY' | translate }}
        </p>
        <div class="google-links">
          <a href="https://www.google.com/intl/en/policies/terms" target="_blank">
            {{ 'GOOGLE_TERMS' | translate }}
            <ion-icon name="open-outline"></ion-icon>
          </a>
          <a href="https://www.google.com/policies/privacy" target="_blank">
            {{ 'GOOGLE_POLICY' | translate }}
            <ion-icon name="open-outline"></ion-icon>
          </a>
        </div>
      </div>
    </ng-container>
    <!-- if multiple results -->
  </div>
  <!-- Places Selection Modal - Centered Dialog -->
  <ion-modal #placesModal [isOpen]="showPlacesModal" (didDismiss)="onPlacesModalDismiss()" [breakpoints]="[0, 1]"
    [initialBreakpoint]="1" class="location-selection-modal">
    <ng-template>
      <div class="modal-wrapper">
        <div class="modal-header">
          <h2>{{ 'SELECT_LOCATION' | translate }}</h2>
          <button class="close-btn" (click)="closePlacesModal()">
            <ion-icon name="close"></ion-icon>
          </button>
        </div>

        <div class="modal-content">
          <ion-list lines="full">
            <ion-item *ngFor="let place of searchResults" button (click)="selectPlace(place)" class="location-item">
              <ion-label>
                <h2>{{ place.formatted_address }}</h2>
                <p>{{ 'LATITUDE' | translate }} °: {{ place.geometry.location.lat | number:'1.7-7' }}</p>
                <p>{{ 'LONGITUDE' | translate }} °: {{ place.geometry.location.lng | number:'1.7-7' }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
      </div>
    </ng-template>
  </ion-modal>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>